import BaseElement from './BaseElement'
import { OmneoCommunicationPreferences } from '../components/OmneoCommunicationPreferences'

export default class OmneoCommunicationPreferencesElement extends BaseElement {
  renderElement() {
    this.rootElement.render(<OmneoCommunicationPreferences />)
  }
}
